import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import useFilteredRoutes from './useFilteredRoutes';

const RouteList = () => {
  const filteredRoutes = useFilteredRoutes();
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {filteredRoutes.map((item) => (
          <Route key={item.path} path={item.path} element={item.element} />
        ))}
      </Routes>
    </Suspense>
  );
};

export default RouteList;
